import { useSignupDispatch } from "components/Signup/store/hooks";
import {
  useAllAnimals,
  useAllValidAnimals,
  useCurrentAnimal,
} from "components/Signup/store/selectors/animals";
import styles from "./AnimalsTabs.module.css";
import { Typography } from "ui-kit/Typography";
import classNames from "classnames";
import { switchAnimal } from "components/Signup/store/slices/animals";
import { useSequentialAnimals } from "components/Signup/flow/SignupFlow/useSequentialAnimals";

export const AnimalsTabs = () => {
  const animals = useAllValidAnimals();
  const dispatch = useSignupDispatch();

  const { currentAnimalIndex } = useSequentialAnimals();

  return (
    <div className={styles.container}>
      <div className={styles.innerContainer}>
        {animals.map((animal, index) => (
          <div
            className={classNames(
              styles.tab,
              currentAnimalIndex === index && styles.active
            )}
            key={animal.name}
            onClick={() => {
              scrollTo({ top: 0, behavior: "smooth" });
              dispatch(switchAnimal(animal.id));
            }}
          >
            <Typography variant="body2" color="blue300">
              <strong>{animal.name}</strong>
            </Typography>
          </div>
        ))}
      </div>
    </div>
  );
};
